import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=53ec0e10&scoped=true"
import script from "./activities.vue?vue&type=script&lang=js"
export * from "./activities.vue?vue&type=script&lang=js"
import style0 from "./activities.vue?vue&type=style&index=0&id=53ec0e10&prod&lang=scss"
import style1 from "./activities.vue?vue&type=style&index=1&id=53ec0e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec0e10",
  null
  
)

export default component.exports